import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tooltip, Flex } from 'antd';
import { PushpinOutlined } from '@ant-design/icons';
import { txt } from 'libs/i18n';
import DeleteIcon from '../DeleteIcon';
const BadgeIcon = ({ onModalOpen, tag, onTagDelete }) => {
    const saveIcon = (_jsx(Tooltip, { title: txt('saveTag'), children: _jsx(PushpinOutlined, { onClick: () => onModalOpen === null || onModalOpen === void 0 ? void 0 : onModalOpen(true) }) }));
    if (tag.showFullVersion === false) {
        return null;
    }
    return (_jsxs(Flex, { children: [saveIcon, _jsx(DeleteIcon, { onTagDelete: onTagDelete, tag: tag })] }));
};
export default BadgeIcon;
